import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'
import { buildDeactivatePayload } from 'utility/user-deactivate'

class Users {
    getUsers(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(
            `${APIPath.users}?${params}`,
        )
    }

    getTeamUsers(queryParams) {
        if (queryParams) {
            const params = CommonUtility.objectToParams(queryParams)
            return BaseService.get(
                `${APIPath.teamMember}?${params}`,
            )
        }
        return BaseService.get(
            `${APIPath.teamMember}`,
        )
    }

    getRoles() {
        return BaseService.get(APIPath.role)
    }

    adminCreate(data) {
        return BaseService.post(APIPath.adminCreateUser, data)
    }

    /**
     * Deactivates ANOTHER user of the company (admins only) through user/Update with IsActive false.
     * The member's current name / phone / role / image are sent along because user/Update writes them.
     */
    deactivateMember(member) {
        const payload = buildDeactivatePayload(member)
        if (!payload) return Promise.reject({ error: { Message: 'This user cannot be deactivated.' } })
        return BaseService.post(APIPath.userUpdate, payload)
    }

    /**
     * Body is empty. "Delete my account": works only on the signed-in user's own id (400 for anyone else)
     * and DELETES the account. Use deactivateMember for other users.
     */
    deactivateUser(uniqueId) {
        const id = Number(uniqueId)
        if (!Number.isInteger(id) || id <= 0) {
            return Promise.reject({
                error: {
                    message: 'This team member has no numeric id, so they cannot be deactivated.',
                },
            })
        }
        return BaseService.postNoBody(APIPath.deactivateUser(id))
    }

    /** Body is empty. Removes a pending invitation, not an active user. */
    removeInvitedTeamMember(uniqueId) {
        return BaseService.postNoBody(APIPath.removeInvitedTeamMember(uniqueId))
    }
}

const UsersService = new Users()
Object.freeze(UsersService)
export { UsersService }
